import DirectoryPlus from '../../../components/Directory/DirectoryPlus';
import styles from "./index.less";
import {useState, useCallback} from "react";
import {Empty, Modal, message} from "antd";
import HttpTool from "../../../tool/HttpTool";
import ModalBase from "../../../components/modalBase";
import { modalType } from '../../../components/ModalGlobal';
import ProtocolList from "./ProtocolList";
import APILXD from "../../../http/APILXD";

const MB = new ModalBase();
export default function (props) {
  const [lastPathItem, setLastPathItem] = useState()

  //获取数据
  const getTreeData = ()=>{
    return new Promise((resolve, reject) => {
      console.log('获取分组');

      HttpTool.post(
        APILXD.getAgreementGroupList,
        (code,msg,json) => {
          resolve(json);
        },
        (code, msg) => {
          reject(msg);
        },
        {},
      );
    });
  }

  //删除
  const deleteTableGroup = useCallback((data)=>{
    return new Promise((resolve, reject) => {
      Modal.confirm({
        ...modalType.modalSmall,
        title: '提示',
        content: `确认删除${data.isGroup ? '分组' : '协议'}【${data.name}】吗？`,
        onOk: () => {
          //请求删除接口
          HttpTool.post(
            data.isGroup ? APILXD.delAgreementGroup : '',
            () => {
              message.success('删除成功');

              if (data._id === lastPathItem?._id) {
                setLastPathItem(null)
              }

              resolve();
            },
            (code, msg) => {
              Modal.warn({
                ...modalType.modalSmall,
                title: '提示',
                content: msg,
              });
            },
            { _id: data._id },
          );
        },
        onCancel: () => {
          reject();
        },
      });
    });
  },[lastPathItem])

  //新增、编辑分组
  const editTableGroup = (data, parentNode)=> {
    return new Promise((resolve, reject) => {
      let addUrl = APILXD.createAgreementGroup;
      let editUrl = APILXD.editAgreementGroup;

      MB.show(
        {
          ...modalType.modalMiddle,
          title: data ? '编辑分组' : '创建分组',
          okTitle: '保存',
          closeTitle: '取消',
        },
        {
          colCount: 1,
          formItemLayout: {
            labelCol: { span: 5 },
            wrapperCol: { span: 16, offset: 0 },
          },
          parameterArr: [
            {
              ver: true,
              name: '分组名称',
              field: 'name',
              reg: /^[\s\S]{1,20}$/,
              verMessage: '请输入分组名称',
              type: 'Input',
              required: true,
              option: {
                placeholder: '请输入分组名称，最多20个字符',
                maxLength: 20,
                defaultValue: data ? data.name : undefined,
              },
            },
          ],
        },
        {
          noMessage: true,
          otherParam: data
            ? {
              _id: data._id,
            }
            : {
              sort: 1,
              groupId: parentNode ? parentNode._id : null,
            },
          url: data ? editUrl : addUrl,
          beforeSubmit: (param) => {
            return true;
          },
          callBack: (state, msg) => {
            //添加成功回调
            console.log(state);
            console.log(msg);
            if (state === 'success') {
              message.success('成功');
              resolve();
            } else {
              message.warning(msg);
            }
          },
        },
      );
    });
  }

  //分组内的分组排序
  const sortGroup = (parentItem, sortChildren)=> {
    return new Promise((resolve, reject) => {
      let maxNum = sortChildren?.length;
      let url = APILXD.editAgreementSort;

      HttpTool.post(
        url,
        (data, error, msg, option) => {
          message.success('排序成功');
          resolve();
        },
        (code, msg) => {
          Modal.warn({ ...modalType.modalSmall, title: '提示', content: msg });
          reject();
        },
        {
          _id: parentItem ? parentItem._id : null,
          list: sortChildren.map((eachItem, index) => {
            return {
              _id: eachItem._id,
              isGroup: eachItem.isGroup,
              sort: maxNum - index,
            };
          }),
        },
      );
    });
  }

  //移动目录（需要更新sort）
  const changeGroup = (parentItem, childItem, sortChildren)=> {
    let maxNum = sortChildren?.length;
    return new Promise((resolve, reject) => {
      HttpTool.post(
        APILXD.editAgreementSort,
        (code,msg,json) => {
          message.success('成功');
          resolve();
        },
        (code, msg) => {
          Modal.warn({ ...modalType.modalSmall, title: '提示', content: msg });
          reject();
        },
        {
          _id: childItem._id,
          parentId: parentItem ? parentItem._id : null,
          isGroup: childItem.isGroup,
          list: sortChildren.map((eachItem, index) => {
            return {
              _id: eachItem._id,
              isGroup: eachItem.isGroup,
              sort: maxNum - index,
            };
          }),
        },
      );
    });
  }

  console.log("props.post?.groupId",props.post)

  return <div
    className={styles.mainPage}
  >
    <div
      className={styles.leftBox}
    >
      <DirectoryPlus
        theme={"light"}
        title={"协议目录"}
        staticConfig={{
          maxLevel: 4,
          showGroupNum: true,
          showEmptyMark: false,
          couldAddItem: false,
          couldEditItem: false,
          couldDeleteItem: false,
        }}
        fieldsConfig={{
          title: 'name',
          id: '_id',
          isGroup: 'isGroup',
          children: 'child',
        }}
        selectConfig={props.post?.defaultGroupId?{
          defaultSelect: {
            _id: props.post?.defaultGroupId,
          },
        }:{}}
        initAutoSelect={(firstSel) => {
          setLastPathItem(firstSel)
        }}
        onClickTreeItem={(selectNode, nodePath) => {
          console.log('点击了节点');
          console.log(selectNode);
          console.log(nodePath);
          setLastPathItem(selectNode)
        }}
        requestTreeData={()=>{
          return getTreeData()
        }}
        onDelete={(targetTree)=>{
          console.log('需要被删除的数据', targetTree);
          return deleteTableGroup(targetTree)
        }}
        onAddGroup={(parentItem) => {
          console.log('新增分组，新增到这一层', parentItem);
          return editTableGroup(null, parentItem);
        }}
        onEditGroup={(targetTree) => {
          console.log('需要编辑的分组', targetTree);
          return editTableGroup(targetTree, null);
        }}
        onAddItem={(parentItem) => {
        }}
        onEditItem={(targetTree) => {
        }}
        onSort={(parentItem, sortChildren) => {
          console.log('触发排序');
          console.log('parentItem为父级，不存在则代表排序顶层内容', parentItem);
          console.log('sortChildren为新的已经排序好的子项数组', sortChildren);

          return sortGroup(parentItem, sortChildren);
        }}
        onChangeGroup={(parentItem, childItem, sortChildren) => {
          console.log('触发移动到别的分组');
          console.log('parentItem为父级，不存在则代表移动到顶层', parentItem);
          console.log('childItem为被移动的项目', childItem);
          console.log('sortChildren为修改后新的层级排序结果', sortChildren);

          return changeGroup(parentItem, childItem, sortChildren);
        }}
      />
    </div>
    <div
      className={styles.rightBox}
    >
      {
        lastPathItem?.isGroup===1
          ?<div className={styles.listBox}>
            <ProtocolList
                {...props}
                key={lastPathItem._id}
                groupId={lastPathItem._id}
            />
          </div>
          :<div>
            <Empty
              description={"请选择协议分组"}
            />
          </div>
      }
    </div>
  </div>
}